import React, { useState, useRef } from 'react';
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Form from '../../../adminpanel/components/commonComponents/Form.v2';
//import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';

export const FilterComponent = ({ filterText, onFilter, onClear, placeHolderValue,responsivenessSearch }) => (
    <>
        <div className={`d-flex ${responsivenessSearch === true ? "responsive-search" :""}`}>
            {/* <div className="search-form">
                <input className="form-control" id="search" type="text" autoComplete="off" placeholder={placeHolderValue ? `Search by ${placeHolderValue}` : "Search"} aria-label="Search Input" value={filterText} onChange={onFilter} />
                <button className="btn btn-white" type="button" onClick={onClear}><i className="fas fa-window-close" aria-hidden="true"></i></button>
            </div> */}
            <input type="search" className="form-control form-control-sm" placeholder={placeHolderValue ? `Search by ${placeHolderValue}` : "Search"} value={filterText} onChange={onFilter} />
        </div>
    </>
);

export const ButtonComponent = ({ buttonData }) => {
    return (
        <>
            <a type="button" key={buttonData.key ? buttonData.key : null} id={buttonData.id ? buttonData.id : null} className={buttonData.className ? buttonData.className : "btn btn-primary btn-sm text-white"} href={buttonData.link ? buttonData.link : "javascript:void(0)"}
                onClick={buttonData.loadingStatus ? null : buttonData.event ? buttonData.event : null} target={buttonData.link ? "_blank" : null}
                disabled={buttonData.loadingStatus ? true : false}>
                {buttonData.loadingStatus ? <span className="spinner-border spinner-border-sm mg-x-5" role="status" aria-hidden="true"></span> : null}
                {buttonData.type == "add" ? <i className="feather mg-r-10" data-feather={buttonData.icon ? buttonData.icon : "plus"} ></i> : null}
                {buttonData.name}
            </a>
        </>
    )
};

export const HoverBtnComponent = ({ btnData, eventParams }) => {
    return <>
        <span className={`btn-hover-type ${btnData.className}`} style={btnData.style} onClick={btnData.eventFunction ? () => btnData.eventFunction(btnData.eventType, eventParams) : null} key={btnData.btnKey ? btnData.btnKey : btnData.className}>
            {btnData.icon == true ? <i className={`feather mg-r-10 ${btnData.iconName ? btnData.iconName.status : null}`} data-feather={btnData.iconName ? btnData.iconName.icon : null} ></i> : null}
            {btnData.btnName}
        </span>
    </>
}

export const EditButton = ({ state, stateToSet, data, rowNumber, columnName }) => {
    const [inputValue, setInputValue] = useState(data[columnName.selector]);
    const handleInputChange = (e) => {
        let value = e.target.value.trim();
        setInputValue(value);
    }
    const handleSaveClick = (e) => {
        e.preventDefault();
        stateToSet(inputValue, rowNumber, data, columnName.selector);
    }
    const popover = (
        <Popover id="popover-basic">
            <Popover.Content>
                <form onSubmit={handleSaveClick}>
                    <input type="text" id={`edit_${rowNumber}`} className="form-control mg-b-10" autoComplete="off" required defaultValue={data[columnName.selector]} onChange={handleInputChange}></input>
                    <div className="d-flex justify-content-end">
                        <button type='button' className="btn btn-white btn-same mg-r-10 edit_cancel" onClick={(e) => { e.preventDefault(); document.getElementById("app").click() }}>Cancel</button>
                        <button type='submit' className="btn btn-primary btn-same edit_save">Save</button>
                    </div>
                </form>
            </Popover.Content>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={popover}
            rootClose
        >
            <button type="button" className="btn edit" id={`edit_${rowNumber}_EditButton`}><i title="Edit" className="fas fa-edit"></i></button>
        </OverlayTrigger>
    );
}

export const MultipleInput = ({ state, stateToSet, data, rowNumber, columnName, connectionType = null}) => {
    const [dropdownValue, setdropdownValue] = useState("");

    let freq_value = data['frequency'] && data['frequency'] !== null && JSON.parse(data['frequency']).freq_type ? JSON.parse(data['frequency']).freq_type : dropdownValue;
    let time = data['frequency'] && data['frequency'] !== null && JSON.parse(data['frequency']).timeOfDay ? JSON.parse(data['frequency']).timeOfDay : "";
    let week = data['frequency'] && data['frequency'] !== null && JSON.parse(data['frequency']).dayOfWeek ? JSON.parse(data['frequency']).dayOfWeek : "";
    let month = data['frequency'] && data['frequency'] !== null && JSON.parse(data['frequency']).dayOfMonth ? JSON.parse(data['frequency']).dayOfMonth : "";

    let filterForm = {};
    let formVar = {
        dbEdit: {
            "type": {
                "name": "type", "label": "Frequency", "type": "dropdown", "text_value": freq_value, "options": [
                    { "name": "Select Frequency", "value": "" },
                    { "name": "Once", "value": "once" },
                    { "name": "Daily", "value": "daily" },
                    { "name": "Weekly", "value": "weekly" },
                    { "name": "Monthly", "value": "monthly" },
                ], "requiredFlag": true
            },
            "time": {
                "name": "time", "label": "Time", "type": "time", "text_value": time, "requiredFlag": true
            },
            "dayOfWeek": {
                "name": "dayOfWeek", "label": "Day of Week", "type": freq_value === "weekly" ? "dropdown" : "hide", "text_value": week,
                "options": [{ "name": "Select Day", "value": "" },
                { "name": "Sunday", "value": "sun" },
                { "name": "Monday", "value": "mon" },
                { "name": "Tuesday", "value": "tue" },
                { "name": "Wednesday", "value": "wed" },
                { "name": "Thursday", "value": "thu" },
                { "name": "Friday", "value": "fri" },
                { "name": "Saturday", "value": "sat" }
                ], requiredFlag: true
            },
            "dayOfMonth": {
                "name": "dayOfMonth", "label": "Day of Month", "type": freq_value === "monthly" ? "number" : "hide", "text_value": month, "min": "1", "max": "31", requiredFlag: true
            }
        },
        sftpEdit: {
            "separator": {
                "name": "separator", "label": "Field seperated by?", "type": "dropdown", "text_value": dropdownValue, "options": [
                    { "name": "Comma (,)", "value": "," },
                    { "name": "Semicolon (;)", "value": ";" },
                    { "name": "Pipe (|)", "value": "|" }
                ], "requiredFlag": true
            }
        }
    }
    filterForm = connectionType === null || ['mysql', "postgres", "oracle", "sqlserver"].indexOf(connectionType.toLowerCase()) > -1 ? formVar['dbEdit'] : formVar['sftpEdit'];
    const [formArray, setFormArray] = useState(JSON.parse(JSON.stringify(filterForm)))

    const handleDropDown = (e) => {
        let tempFormData = JSON.parse(JSON.stringify(formArray));
        tempFormData[e.target.name]['text_value'] = e.target.value.trim();
        if (e.target.name === "type") {
            switch (e.target.value) {
                case "daily":
                case "once":
                    tempFormData['dayOfMonth']['type'] = "hide";
                    tempFormData['dayOfWeek']['type'] = "hide";
                    break;
                case "weekly":
                    tempFormData['dayOfMonth']['type'] = "hide";
                    tempFormData['dayOfWeek']['type'] = "dropdown";
                    break;
                case "monthly":
                    tempFormData['dayOfWeek']['type'] = "hide"
                    tempFormData['dayOfMonth']['type'] = "number";
                    break;
            }
        }
        setFormArray(tempFormData);
    }

    const handleSaveClick = (event) => {
        event.preventDefault();
        var formData = {}
        $("#multipleInputPopoverForm").serializeArray().map(function (innerData) {
            formData[innerData.name] = innerData.value;
        })
        stateToSet(formData, rowNumber, data, columnName.selector);
    }

    const popover = (
        <Popover id="popover-basic" className="wd-50p">
            <Popover.Content>
                <form id="multipleInputPopoverForm" onSubmit={handleSaveClick}>
                    < Form label_array={formArray} handle_form_drop_down={handleDropDown} />
                    <div className="d-flex justify-content-end">
                        <button
                            type='button'
                            className="btn btn-white btn-same mg-r-10 edit_cancel"
                            onClick={(e) => {
                                e.preventDefault();
                                setdropdownValue("");
                                connectionType === null || ['mysql', "postgres", "oracle", "sqlserver"].indexOf(connectionType.toLowerCase()) > -1 ? setFormArray(formVar['dbEdit']) : setFormArray(formVar['sftpEdit'])
                                document.getElementById("app").click()
                            }}
                        >Cancel
                        </button>
                        <button type='submit' className="btn btn-primary btn-same edit_save">Save</button>
                    </div>
                </form>
            </Popover.Content>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={popover}
            rootClose
        >
            <button type="button" className="btn" id={`edit_${rowNumber}_multipleInput`}><i title="Edit" className="fas fa-edit"></i></button>
        </OverlayTrigger>
    );
}

export const DropDownComponent = ({ state, stateToSet, dropdownOption, dropDownValue, data, rowNumber, columnName }) => {
    const [dropdownValue, setdropdownValue] = useState(dropDownValue);
    const handleDropDown = (e) => {
        setdropdownValue(e.target.value)
    }
    const handleSaveClick = (event) => {
        event.preventDefault();
        var formData = {}
        $("#multipleInputPopoverForm").serializeArray().map(function (innerData) {
            formData[innerData.name] = innerData.value;
        })
        stateToSet(formData, rowNumber, data, columnName.selector);
    }
    let formVar = {
        ddEdit: {
            "columnName.selector": {
                "name": columnName.selector, "label": columnName.name, "type": "dropdown", "text_value": dropdownValue, "options": dropdownOption, "requiredFlag": true
            }
        }
    }
    let filterForm = formVar['ddEdit']

    const popover = (
        <Popover id="popover-basic" className="wd-50p">
            <Popover.Content>
                <form id="multipleInputPopoverForm" onSubmit={handleSaveClick}>
                    <Form label_array={filterForm} handle_form_drop_down={handleDropDown} />
                    <div className="d-flex justify-content-end">
                        <button
                            type='button'
                            className="btn btn-white btn-same mg-r-10 edit_cancel"
                            onClick={(e) => { e.preventDefault(); setdropdownValue(dropDownValue); document.getElementById("app").click() }}
                        >Cancel
                        </button>
                        <button type='submit' className="btn btn-primary btn-same edit_save">Save</button>
                    </div>
                </form>
            </Popover.Content>
        </Popover>
    );
    return (
        <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={popover}
            rootClose
        >
            <button type="button" className="btn edit" id={`edit_${rowNumber}`}><i title="Edit" className="fas fa-edit"></i></button>
        </OverlayTrigger>
    );
}